import EpiComponent from '@episerver/spa-core/EpiComponent';
import FamilyMemberCellularSaleBlockData from 'Models/Content/FamilyMemberCellularSaleBlockData';
import React, {ReactNode, ReactNodeArray} from 'react';
import FamilyMemberCellularSaleMain from './FamilyMemberCellularSaleMain.js';

export default class FamilyMemberCellularSaleBlock extends EpiComponent<FamilyMemberCellularSaleBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <FamilyMemberCellularSaleMain context={this.getContext()} iContent={this.props.data} />;
  }
}
